/**
 * @generated SignedSource<<10aae1d80577a26ab8c4de3675002f7e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type EntitiesAvatarFragment$data = {
  readonly edges: ReadonlyArray<{
    readonly node: {
      readonly username: string;
      readonly " $fragmentSpreads": FragmentRefs<"EntityProfilePicFragment">;
    };
  }>;
  readonly " $fragmentType": "EntitiesAvatarFragment";
};
export type EntitiesAvatarFragment$key = {
  readonly " $data"?: EntitiesAvatarFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"EntitiesAvatarFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "EntitiesAvatarFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "EntityEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": null,
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "username",
              "storageKey": null
            },
            {
              "args": [
                {
                  "kind": "Literal",
                  "name": "thumbnail",
                  "value": true
                }
              ],
              "kind": "FragmentSpread",
              "name": "EntityProfilePicFragment"
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "VotersConnection",
  "abstractKey": null
};

(node as any).hash = "41c7cdb06b50ec07c9195d6a4e8c412b";

export default node;
